import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";
import {
  jamfSnippet,
  kandjiSnippet,
  manualSnippet,
  mosyleSnippet,
} from "./installerCopy";
import type { InstallerBuild } from "@/types/edr-installers";

function CopyBlock({ text }: { text: string }) {
  const [copied, setCopied] = useState(false);
  return (
    <div className="relative">
      <pre className="overflow-x-auto rounded border border-border bg-muted/40 p-3 text-[11px] leading-relaxed font-mono whitespace-pre">
        {text}
      </pre>
      <Button
        size="sm"
        variant="ghost"
        className="absolute right-2 top-2 h-7 px-2"
        onClick={() => {
          navigator.clipboard.writeText(text).then(() => {
            setCopied(true);
            toast.success("Copied");
            setTimeout(() => setCopied(false), 1500);
          });
        }}
      >
        {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
      </Button>
    </div>
  );
}

export function MdmSnippetTabs({ build }: { build: InstallerBuild }) {
  const macos = build.platform === "macos";
  return (
    <Tabs defaultValue="manual" className="w-full">
      <TabsList className="h-9">
        <TabsTrigger value="manual" className="text-xs">Manual</TabsTrigger>
        <TabsTrigger value="jamf" disabled={!macos} className="text-xs">Jamf Pro</TabsTrigger>
        <TabsTrigger value="kandji" disabled={!macos} className="text-xs">Kandji</TabsTrigger>
        <TabsTrigger value="mosyle" disabled={!macos} className="text-xs">Mosyle</TabsTrigger>
      </TabsList>
      <TabsContent value="manual" className="mt-3">
        <CopyBlock text={manualSnippet(build)} />
      </TabsContent>
      <TabsContent value="jamf" className="mt-3">
        <CopyBlock text={jamfSnippet(build)} />
      </TabsContent>
      <TabsContent value="kandji" className="mt-3">
        <CopyBlock text={kandjiSnippet(build)} />
      </TabsContent>
      <TabsContent value="mosyle" className="mt-3">
        <CopyBlock text={mosyleSnippet(build)} />
      </TabsContent>
    </Tabs>
  );
}
